import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-50 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-tv-2-line text-lg"></i>
                </span>
                <span className="font-heading text-lg text-foreground-950">人人美剧</span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                人人美剧是您追剧的最佳平台，提供海量最新美剧、经典美剧免费在线观看，支持高清播放、中英文字幕。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-950 mb-4">快速导航</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">分类浏览</Link></li>
                <li><Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">剧情美剧</Link></li>
                <li><Link to="/category/sci-fi" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">科幻美剧</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-950 mb-4">热门推荐</h4>
              <ul className="space-y-2.5">
                <li><Link to="/article/1" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">权力的游戏</Link></li>
                <li><Link to="/article/3" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">绝命毒师</Link></li>
                <li><Link to="/article/5" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">老友记</Link></li>
                <li><Link to="/article/2" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">怪奇物语</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-sm text-foreground-950 mb-4">关于我们</h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">联系我们</Link></li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">
                    隐私政策
                  </a>
                </li>
                <li>
                  <a href="#" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">
                    用户协议
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-background-200/70">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} 人人美剧 RenrenMeiju. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
                <a href="#" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap" rel="nofollow">Cookie 政策</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}